import axios from "axios";

export const postOrder = (orderDto) => {
    return axios.post("https://fire-hose-complete-backend.onrender.com/fire-hose-management/orders", orderDto).then((response) => {
        return response;
    });
};
